<template>
    <div class="patent-list-tab display-flex flex-column pt-md w-100">
        <AonContainer class="display-flex flex-column flex-grow-1">
            <AonRow class="display-flex flex-column flex-grow-1">
                <AonSpinner
                    v-if="entityStore.loadingEntity || !entityStore.entity"
                    class="mx-auto"
                    :scale="0.5"
                    color="castleMoat"
                />
                <div v-else class="grid-holder w-100 display-flex flex-column flex-grow-1">
                    <h5 class="display-flex flex-column flex-grow-1">Patent List</h5>
                    <p class="mb-md mt-xxs display-flex flex-column flex-grow-1">
                        Explore all patents associated with {{ entityStore.entity.name }}. Use the
                        available filters to refine the list and export as needed.
                    </p>
                    <AonCol class="grid-cols-12 display-flex flex-column flex-grow-1">
                        <PatentList
                            inline
                            entity-only
                            :entity-pk="parseInt(entityStore.entity.aon_entity_pk)"
                        />
                    </AonCol>
                </div>
            </AonRow>
        </AonContainer>
    </div>
</template>

<script setup>
import { computed, ref, watchEffect } from 'vue'
import { useEntityStore } from '@/stores'

import PatentList from '@/components/patentViewer/PatentList.vue'

const entityStore = useEntityStore()
</script>
<style lang="scss" scoped>
.patent-list-tab {
    height: calc(100% - 150px);
}
</style>
